import React, { useState, useCallback, useRef } from "react";
import TrackTrace from "./TrackTrace";
import CompetencyDashboard from "../../components/CompetencyDashboard";
import BiographicsDashboard from "../../components/BiographicsDashboard";
import RequestSummariesDashboard from "../../components/RequestSummariesDashboard";
import { 
    Box, 
    Heading, 
    Button, 
    useToast, 
    Text, 
    VStack,
    Tabs,
    TabList,
    TabPanels,
    Tab,
    TabPanel
} from "@chakra-ui/react";
import { FaUpload } from "react-icons/fa";

const API_BASE_URL = "https://qaapirgeneng.digitalfields.co.za/ws1.cfc";

function Home() {
    const toast = useToast();
    const [file, setFile] = useState(null);
    const [isUploading, setIsUploading] = useState(false);
    const fileInputRef = useRef(null);

    const HuserID = localStorage.getItem("HuserID");
    const UUID = localStorage.getItem("UUID");

    const handleFileChange = useCallback((event) => {
        const selectedFile = event.target.files[0];
        setFile(selectedFile);
    }, []);

    const handleUpload = useCallback(async () => {
        if (!file) {
            toast({
                title: "No file selected",
                description: "Please select an Excel file to upload.",
                status: "warning",
                duration: 5000,
                isClosable: true,
            });
            return;
        }

        setIsUploading(true);
        const formData = new FormData();
        formData.append("uploadfile", file);

        try {
            const response = await fetch(
                `${API_BASE_URL}?method=uploadScoresSheet&huserID=${HuserID}&hclientID=1&UUID=${UUID}`,
                {
                    method: "POST",
                    body: formData,
                }
            );

            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(
                    errorData.message || "Network response was not ok"
                );
            }

            const data = await response.text();
            console.log(data);

            toast({
                title: "Upload successful",
                description: "The file has been uploaded successfully.",
                status: "success",
                duration: 2000,
                isClosable: true,
            });

            // Reset file input and state after successful upload
            setFile(null);
            if (fileInputRef.current) {
                fileInputRef.current.value = "";
            }
        } catch (error) {
            console.error(
                "There was a problem with the fetch operation:",
                error
            );
            toast({
                title: "Upload failed",
                description:
                    error.message || "There was an error uploading the file.",
                status: "error",
                duration: 5000,
                isClosable: true,
            });
        } finally {
            setIsUploading(false);
        }
    }, [file, HuserID, toast]);

    return (
        <Box p={6}>
            <Tabs variant="enclosed" colorScheme="orange">
                <TabList>
                    <Tab>Track and Trace</Tab>
                    <Tab>Competencies</Tab>
                    <Tab>Biographics</Tab>
                    <Tab>Request summaries</Tab>
                </TabList>

                <TabPanels>
                    {/* Track and Trace Tab */}
                    <TabPanel p={0}>
                        <TrackTrace />
                    </TabPanel>

                    {/* Competencies Tab */}
                    <TabPanel p={0}>
                        <CompetencyDashboard />
                    </TabPanel>

                    {/* Biographics Tab */}
                    <TabPanel p={0}>
                        <BiographicsDashboard />
                    </TabPanel>

                    {/* Request summaries Tab */}
                    <TabPanel p={0}>
                        <RequestSummariesDashboard />
                    </TabPanel>
                </TabPanels>
            </Tabs>
        </Box>
    );
}

export default Home;
